(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
/*
 * Replace the seeded --announcement-bar-height with the real rendered height.
 * Romanian copy wraps differently per viewport and per font load, so the
 * measured value is the only reliable one — the seed just prevents a jump
 * before this runs.
 */
(function () {
  var bar = document.querySelector('[data-announcement-bar]');
  if (!bar) return;

  function syncHeight() {
    document.documentElement.style.setProperty(
      '--announcement-bar-height',
      bar.offsetHeight + 'px'
    );
  }

  syncHeight();

  if ('ResizeObserver' in window) {
    new ResizeObserver(syncHeight).observe(bar);
  } else {
    window.addEventListener('resize', syncHeight);
  }

  /* Webfonts land after first paint and can change the wrap point. */
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(syncHeight);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const page = document.querySelector('.cart-page');
  if (!page) return;

  // The section re-renders server-side after every change, so all listeners are
  // delegated to the document and survive the swap. The section id is read off
  // the wrapper Shopify renders around this section.
  const wrapper = page.closest('.shopify-section');
  const sectionId = wrapper ? wrapper.id.replace(/^shopify-section-/, '') : null;

  // Read the cart URL from the form action so no Liquid is needed here. The
  // change endpoint is the cart URL with the .js suffix.
  const form = document.querySelector('.cart-form');
  const cartUrl = form ? form.getAttribute('action') : '/cart';
  const changeUrl = cartUrl.replace(/\/+$/, '') + '/change.js';

  // Last server-confirmed quantity per line key, seeded from the initial render.
  const known = {};
  document.querySelectorAll('.cart-item .quantity-input').forEach((input) => {
    known[input.dataset.key] = parseInt(input.value, 10) || 0;
  });

  // Latest quantity the user has asked for per line key. It is allowed to be
  // ahead of both `known` and the DOM: a section swap resets the inputs to the
  // server value while a newer change is still queued.
  const requested = {};

  // How long to wait after a change before asking the server. Clicks and
  // remove are coalesced quickly; typing waits for the user to pause.
  const CLICK_DEBOUNCE_MS = 200;
  const TYPE_DEBOUNCE_MS = 400;

  // Persistent live region (outside the swapped subtree) that announces totals.
  let liveRegion = document.getElementById('cart-live-region');
  if (!liveRegion) {
    liveRegion = document.createElement('div');
    liveRegion.id = 'cart-live-region';
    liveRegion.className = 'sr-only';
    liveRegion.setAttribute('role', 'status');
    liveRegion.setAttribute('aria-live', 'polite');
    document.body.appendChild(liveRegion);
  }

  const rowFor = (key) => document.querySelector(`.cart-item[data-key="${key}"]`);
  const inputFor = (key) => document.querySelector(`.quantity-input[data-key="${key}"]`);

  // The quantity a click applies to: the latest thing the user asked for, then
  // whatever the input shows, then the last server confirmation.
  const baseQuantity = (key) => {
    if (requested[key] !== undefined) return requested[key];
    const input = inputFor(key);
    const parsed = input ? parseInt(input.value, 10) : NaN;
    return Number.isNaN(parsed) ? known[key] ?? 0 : Math.max(0, parsed);
  };

  // A section swap resets every input to the server value. Re-apply the
  // quantities the user has requested but the server hasn't confirmed yet, so
  // the DOM matches the queue.
  const applyRequested = () => {
    Object.keys(requested).forEach((key) => {
      const input = inputFor(key);
      if (input && requested[key] !== known[key]) input.value = requested[key];
    });
  };

  // The header badge is owned by assets/cart.js, which listens for the
  // `cart:updated` event dispatched below. This script must not touch the
  // badge itself, or the count would update twice per change.

  const showError = (key, message) => {
    const row = rowFor(key);
    if (!row) return;
    row.querySelector('.cart-item__error')?.remove();
    const details = row.querySelector('.cart-item__details');
    const error = document.createElement('p');
    error.className = 'cart-item__error';
    error.textContent = message;
    details?.appendChild(error);
  };

  // Re-sync every input after a failed change, so a rejected value doesn't
  // linger in the DOM: anything still queued wins, everything else falls back
  // to the last server confirmation.
  const syncInputs = () => {
    document.querySelectorAll('.cart-item .quantity-input').forEach((input) => {
      const key = input.dataset.key;
      const value = requested[key] ?? known[key];
      if (value !== undefined) input.value = value;
    });
  };

  // Read the already-formatted total straight out of the swapped DOM, so the
  // live region never does its own locale/currency formatting.
  const totalText = () => {
    const el = document.querySelector('.cart-summary__row--total span:last-child');
    return el ? el.textContent.trim() : '';
  };

  // Re-init the express checkout buttons (Shop / PayPal / …) after the swap
  // re-creates their markup.
  const reinitExpressCheckout = () => {
    window.Shopify?.PaymentButton?.init?.();
  };

  // Capture the cart control that has focus so it can be found again after the
  // swap — the section markup replaces every node, so the selector has to be
  // taken before the new markup goes in.
  const captureFocusSelector = () => {
    const active = document.activeElement;
    if (!(active instanceof Element) || !active.closest('.cart-page')) return null;

    const input = active.closest('.quantity-input[data-key]');
    if (input) return `.quantity-input[data-key="${input.dataset.key}"]`;

    const button = active.closest('.quantity-btn[data-action][data-key]');
    if (button) {
      return `.quantity-btn[data-action="${button.dataset.action}"][data-key="${button.dataset.key}"]`;
    }

    const remove = active.closest('.cart-item__remove-btn[data-key]');
    if (remove) return `.cart-item__remove-btn[data-key="${remove.dataset.key}"]`;

    return null;
  };

  // Restore focus to the control the user was on. Only when nothing in the cart
  // was focused (or that control is gone, e.g. its row was just removed) fall
  // back to the empty-state heading / first input.
  const focusAfterSwap = (selector) => {
    const preferred = selector ? document.querySelector(selector) : null;
    const empty = document.querySelector('.cart-empty h2');
    const firstInput = document.querySelector('.cart-item .quantity-input');
    (preferred || empty || firstInput)?.focus();
  };

  // --- Serialised + coalesced change queue ---------------------------------
  // One in-flight /cart/change.js request at a time, coalescing rapid edits to
  // the latest quantity per key. The previous global `seq` counter dropped a
  // line's response whenever another line changed later, and parallel change.js
  // calls have no ordering guarantee.
  const pending = {}; // key -> { quantity, timer }
  let inFlight = false;

  const pump = async () => {
    if (inFlight) return;
    const key = Object.keys(pending).find((k) => pending[k].quantity !== null);
    if (key === undefined) return;

    inFlight = true;
    const entry = pending[key];
    const quantity = entry.quantity;
    entry.quantity = null;
    clearTimeout(entry.timer);

    try {
      await changeLine(key, quantity);
    } finally {
      inFlight = false;
      // The server has caught up and nothing newer is queued for this key, so
      // the DOM is authoritative again. A removed line has no `known` entry.
      if (entry.quantity === null && (requested[key] === known[key] || known[key] === undefined)) {
        delete requested[key];
      }
      pump();
    }
  };

  const scheduleChange = (key, quantity, immediate, delay) => {
    // A quantity that is already queued or in flight must not be sent again:
    // Enter after a debounced edit or a repeated +/- would otherwise cost a
    // redundant request (and a second remove for 0). While something newer is
    // queued, stepping back to the server value still has to be queued.
    const latest = requested[key];
    if (latest !== undefined ? quantity === latest : quantity === known[key]) return;

    const p = pending[key] || (pending[key] = { quantity: null, timer: 0 });
    requested[key] = quantity;
    p.quantity = quantity;
    clearTimeout(p.timer);
    if (immediate) {
      pump();
    } else {
      p.timer = setTimeout(pump, delay || CLICK_DEBOUNCE_MS);
    }
  };

  // Drop a rejected quantity (unless the user already asked for a newer one
  // while it was in flight) and resync the inputs from the last server value.
  const revert = (key, quantity) => {
    if (requested[key] === quantity) delete requested[key];
    syncInputs();
  };

  const changeLine = async (key, quantity) => {
    const row = rowFor(key);
    row?.classList.add('cart-item--pending');
    row?.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(changeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections: sectionId, sections_url: cartUrl }),
      });
      const data = await response.json().catch(() => null);

      if (!response.ok) {
        revert(key, quantity);
        showError(key, (data && (data.description || data.message)) || 'Nu s-a putut actualiza coșul. Încearcă din nou.');
        return;
      }

      if (data && Array.isArray(data.items)) {
        // Rebuild from the server cart so a line removed in this change drops
        // out of `known` instead of leaving a stale quantity behind.
        const present = new Set(data.items.map((item) => item.key));
        Object.keys(known).forEach((knownKey) => {
          if (!present.has(knownKey)) delete known[knownKey];
        });
        data.items.forEach((item) => { known[item.key] = item.quantity; });
      }

      // Swap the returned section markup in place. Styles persist (they are not
      // re-inserted here), and this script does not re-run because inline
      // scripts are not executed when inserted as HTML.
      const html = data && data.sections && data.sections[sectionId];
      const current = document.querySelector('.cart-page');
      if (html && current) {
        const template = document.createElement('template');
        template.innerHTML = html;
        const next = template.content.querySelector('.cart-page');
        if (next) {
          const focusSelector = captureFocusSelector();
          current.replaceWith(next);
          applyRequested();
          focusAfterSwap(focusSelector);
          reinitExpressCheckout();
          if (data) {
            liveRegion.textContent = `Total: ${totalText()}`;
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: data } }));
          }
          return;
        }
      }

      // /cart/change.js returned no swappable section markup (the Sections
      // render can come back null). Reload so the page matches the server cart
      // — the no-JS fallback navigates the same way.
      window.location.reload();
    } catch {
      revert(key, quantity);
      showError(key, 'Nu s-a putut actualiza coșul. Încearcă din nou.');
    } finally {
      row?.classList.remove('cart-item--pending');
      row?.removeAttribute('aria-busy');
    }
  };

  const commitInput = (input) => {
    const key = input.dataset.key;
    const parsed = parseInt(input.value, 10);
    if (Number.isNaN(parsed)) {
      input.value = requested[key] ?? known[key] ?? '';
      return;
    }
    // A value already queued or in flight is a no-op (scheduleChange guards).
    scheduleChange(key, Math.max(0, parsed), true);
  };

  // Enter in a quantity input should commit the value, not submit the form —
  // with JS on there is no update button, so the implicit submit would fire the
  // `name=checkout` button and send the user to checkout mid-edit.
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter') return;
    const input = event.target instanceof Element ? event.target.closest('.quantity-input[data-key]') : null;
    if (!input) return;
    event.preventDefault();
    commitInput(input);
  });

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const quantityButton = target.closest('.quantity-btn[data-action][data-key]');
    if (quantityButton) {
      const key = quantityButton.dataset.key;
      // Base the step on the latest requested quantity, not the DOM value: a
      // swap can reset the input to the server value while a newer change is
      // still queued, and stepping off that stale value loses the click.
      const base = baseQuantity(key);
      const value = quantityButton.dataset.action === 'increase' ? base + 1 : Math.max(0, base - 1);
      const input = inputFor(key);
      if (input) input.value = value;
      scheduleChange(key, value);
      return;
    }

    const removeLink = target.closest('.cart-item__remove-btn[data-key]');
    if (removeLink) {
      event.preventDefault();
      scheduleChange(removeLink.dataset.key, 0, true);
    }
  });

  document.addEventListener('input', (event) => {
    const input = event.target instanceof Element ? event.target.closest('.quantity-input[data-key]') : null;
    if (!input) return;
    const parsed = parseInt(input.value, 10);
    if (Number.isNaN(parsed)) return;
    scheduleChange(input.dataset.key, Math.max(0, parsed), false, TYPE_DEBOUNCE_MS);
  });

  document.addEventListener('change', (event) => {
    const input = event.target instanceof Element ? event.target.closest('.quantity-input[data-key]') : null;
    if (input) commitInput(input);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const sortSelect = document.getElementById('SortBy');
  const filtersForm = document.getElementById('CollectionFiltersForm');

  sortSelect?.addEventListener('change', () => {
    sortSelect.form?.submit();
  });

  filtersForm?.querySelectorAll('.collection-filter input[type="checkbox"]').forEach(input => {
    input.addEventListener('change', () => {
      filtersForm.submit();
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
const navbar = document.getElementById('navbar');
const toggle = document.getElementById('navbar-toggle');
const mobileMenu = document.getElementById('navbar-mobile-menu');
let lastScrollTop = 0;

// Toggle mobile menu
toggle?.addEventListener('click', () => {
  const isOpen = mobileMenu?.classList.toggle('active');
  toggle?.classList.toggle('active');
  toggle?.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  document.body.style.overflow = isOpen ? 'hidden' : '';
});

// Close mobile menu when clicking on a link
const mobileLinks = mobileMenu?.querySelectorAll('a');
mobileLinks?.forEach(link => {
  link.addEventListener('click', () => {
    mobileMenu?.classList.remove('active');
    toggle?.classList.remove('active');
    toggle?.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  });
});

// Navbar scroll effect
let ticking = false;

window.addEventListener('scroll', () => {
  if (!ticking) {
    window.requestAnimationFrame(() => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > 100) {
        navbar?.classList.add('scrolled');
      } else {
        navbar?.classList.remove('scrolled');
      }

      lastScrollTop = scrollTop;
      ticking = false;
    });

    ticking = true;
  }
});

/*
 * Publish the navbar's real height so body padding can clear it.
 * The padding used to be hardcoded at 80px/70px while the navbar actually
 * renders 120px/104px, so the first 40px (desktop) or 34px (mobile) of every
 * page sat underneath the fixed header. Measuring keeps the two in step if
 * the logo size or nav wrapping ever changes.
 */
(function () {
  if (!navbar) return;

  function syncNavbarHeight() {
    document.documentElement.style.setProperty('--navbar-height', navbar.offsetHeight + 'px');
  }

  syncNavbarHeight();

  if ('ResizeObserver' in window) {
    new ResizeObserver(syncNavbarHeight).observe(navbar);
  } else {
    window.addEventListener('resize', syncNavbarHeight);
  }

  /* Webfonts land after first paint and can change the nav's line box. */
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(syncNavbarHeight);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-video"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const video = document.getElementById('hero-video');
  const heroTitle = document.querySelector('.hero__title');
  const heroTagline = document.querySelector('.hero__tagline');
  const heroCta = document.querySelector('.hero__cta');

  function showContent() {
    const elements = [heroTitle, heroTagline, heroCta];
    elements.forEach((el, index) => {
      if (el) {
        setTimeout(() => {
          el.classList.add('animate-in');
        }, index * 200);
      }
    });
  }

  if (video) {
    video.play().catch((err) => {
      console.log('Video autoplay failed, showing content immediately');
      showContent();
    });

    setTimeout(() => {
      showContent();
    }, 1000);
  } else {
    showContent();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  // Image thumbnail switching
  const mainImage = document.getElementById('product-main-image');
  const thumbs = document.querySelectorAll('.product-images__thumb');

  // image_tag renders a srcset, which wins over src. Drop it so the swap sticks.
  const setMainImage = url => {
    const path = u => {
      try { return new URL(u, location.href).pathname; } catch (e) { return u; }
    };

    // Keep the responsive srcset while the shown image is already the right one.
    if (path(mainImage.currentSrc || mainImage.src) === path(url)) return;

    mainImage.removeAttribute('srcset');
    mainImage.removeAttribute('sizes');
    mainImage.src = url;
  };

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      const newUrl = thumb.dataset.imageUrl;
      if (mainImage && newUrl) {
        setMainImage(newUrl);
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      }
    });
  });

  // Quantity selector
  const quantityInput = document.getElementById('product-quantity');
  const quantityBtns = document.querySelectorAll('.quantity-btn');

  quantityBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const action = btn.dataset.action;
      let value = parseInt(quantityInput.value) || 1;

      if (action === 'increase') {
        value++;
      } else if (action === 'decrease' && value > 1) {
        value--;
      }

      quantityInput.value = value;
    });
  });

  // Variant selection
  const variantDataScript = document.getElementById('product-variant-data');
  const variantSelects = Array.from(document.querySelectorAll('.product-form__select'));
  const variantIdInput = document.querySelector('.product-form input[name="id"]');
  const addToCartBtn = document.querySelector('.product-form__add-to-cart');
  const priceCurrent = document.getElementById('product-info-current-price');
  const priceCompare = document.getElementById('product-info-compare-price');
  const priceSale = document.getElementById('product-info-sale-price');
  const priceBadge = document.getElementById('product-info-badge');
  const unitPrice = document.querySelector('.product-info__unit-price');

  if (variantDataScript && variantSelects.length > 0 && variantIdInput) {
    const variants = JSON.parse(variantDataScript.textContent);

    const updateVariant = () => {
      const optionIndices = variantSelects.map(select => parseInt(select.dataset.optionIndex, 10));
      const selected = {};
      variantSelects.forEach(select => {
        selected[select.dataset.optionIndex] = select.value.trim();
      });

      const variant = variants.find(v =>
        optionIndices.every(idx => v['option' + (idx + 1)] === selected[idx])
      );

      if (!variant) {
        variantIdInput.value = '';
        if (addToCartBtn) {
          addToCartBtn.disabled = true;
          addToCartBtn.textContent = 'Stoc Epuizat';
        }
        return;
      }

      variantIdInput.value = variant.id;

      if (variant.compare_at_price_str) {
        priceCompare.textContent = variant.compare_at_price_str;
        priceCompare.hidden = false;
        priceSale.textContent = variant.price_str;
        priceSale.hidden = false;
        priceBadge.hidden = false;
        priceCurrent.hidden = true;
      } else {
        priceCurrent.textContent = variant.price_str;
        priceCurrent.hidden = false;
        priceCompare.hidden = true;
        priceSale.hidden = true;
        priceBadge.hidden = true;
      }

      if (unitPrice) {
        unitPrice.textContent = variant.unit_price_str || '';
        unitPrice.hidden = !variant.unit_price_str;
      }

      if (addToCartBtn) {
        addToCartBtn.disabled = !variant.available;
        addToCartBtn.textContent = variant.available ? 'Adaugă în Coș' : 'Stoc Epuizat';
      }

      if (mainImage && variant.featured_image_url) {
        setMainImage(variant.featured_image_url);
      }
    };

    variantSelects.forEach(select => {
      select.addEventListener('change', updateVariant);
    });

    updateVariant();
  }
});

  } catch(e) { console.error(e); }
})();
})();
